import { render, staticRenderFns } from "./MarginEstimasiDetail.vue?vue&type=template&id=e9f2c6f8"
import script from "./MarginEstimasiDetail.vue?vue&type=script&lang=js"
export * from "./MarginEstimasiDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports